// NOTE. Remove React import. if you want to keep React import, you do not filter anything
import React from 'react';
import type { SVGProps } from 'react';
export const SvgArrowUpCorner = (props: SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            d="M10.4393 8.44754C10.0077 8.44754 9.65775 8.09762 9.65775 7.66598C9.65775 7.23434 10.0077 6.88443 10.4393 6.88443L16.3341 6.88443C16.7658 6.88443 17.1157 7.23434 17.1157 7.66598L17.1157 13.5608C17.1157 13.9925 16.7658 14.3424 16.3341 14.3424C15.9025 14.3424 15.5526 13.9925 15.5526 13.5608L15.5526 9.55282L8.41295 16.6925C8.10773 16.9977 7.61288 16.9977 7.30767 16.6925C7.00245 16.3872 7.00245 15.8924 7.30767 15.5872L14.4473 8.44754L10.4393 8.44754Z"
            fill="currentColor"
        />
    </svg>
);
